import videojs from 'video.js';
import 'videojs-xr';
import 'videojs-xr/dist/videojs-xr.css';
import './video360.css';

export class Video360PluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;

    if (presentationData.metadata.is360Video) {
        player.xr();
    }
}